/**
 * 未分配产康安排（GET /project-plan/unassigned 行）上的服务时长、预约日、开始时刻
 * 与 15 分钟可约表对齐，供 UnassignedProjectPlanBookPanel 与 SingleProjectAppointmentForm 共用
 */
import dayjs from 'dayjs'
import {
  getDefaultAppointmentStartHm,
  LAST_SLOT_START_MINUTES,
  SLOT_START_MINUTES,
  TIME_SLOTS
} from '@/utils/technicianBookingTimeSlots'
import { isValidServiceMinutes, normalizeServiceMinutes } from '@/utils/renderUtils'

export function planServiceMinutes (plan) {
  if (!plan || typeof plan !== 'object') return 60
  const a = Number(plan.startTime)
  const b = Number(plan.endTime)
  if (!Number.isFinite(a) || !Number.isFinite(b) || b <= a) return 60
  return Math.max(15, Math.round((b - a) / 60))
}

export function startHmFromPlan (t) {
  if (t == null || t === '') return undefined
  if (typeof t === 'string') {
    const trimmed = t.trim()
    const m = trimmed.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/)
    if (m) {
      const p = dayjs(`2000-01-01 ${m[1].padStart(2, '0')}:${m[2]}`, 'YYYY-MM-DD HH:mm', true)
      if (p.isValid()) return p.format('HH:mm')
    }
  }
  const n = Number(t)
  if (!Number.isFinite(n)) return undefined
  const d = String(Math.abs(n)).length <= 10 ? dayjs.unix(n) : dayjs(n)
  return d.isValid() ? d.format('HH:mm') : undefined
}

export function snapHmToBookingSlotValue (hmStr) {
  if (hmStr == null || hmStr === '') return undefined
  const p = dayjs(`2000-01-01 ${String(hmStr).trim().slice(0, 5)}`, 'YYYY-MM-DD HH:mm', true)
  if (!p.isValid()) return undefined
  const mins = p.hour() * 60 + p.minute()
  if (mins < SLOT_START_MINUTES) return TIME_SLOTS[0]?.value
  if (mins > LAST_SLOT_START_MINUTES) return TIME_SLOTS[TIME_SLOTS.length - 1]?.value
  for (let i = TIME_SLOTS.length - 1; i >= 0; i--) {
    if (TIME_SLOTS[i].startMinutes <= mins) {
      return TIME_SLOTS[i].value
    }
  }
  return TIME_SLOTS[0]?.value
}

export function planInitialStartHm (plan) {
  if (!plan) return undefined
  const raw = startHmFromPlan(plan.startTime)
  return raw != null && raw !== '' ? snapHmToBookingSlotValue(raw) : undefined
}

export function initialAppointmentDate (plan) {
  if (!plan) return dayjs()
  if (plan.startTime != null && plan.startTime !== '') {
    const n = Number(plan.startTime)
    if (Number.isFinite(n)) {
      const d = String(Math.abs(n)).length <= 10 ? dayjs.unix(n) : dayjs(n)
      if (d.isValid()) return d.startOf('day')
    }
  }
  const t = plan.appointmentDate
  if (t == null || t === '') return dayjs()
  const n2 = Number(t)
  if (!Number.isFinite(n2)) return dayjs()
  const d2 = String(Math.abs(n2)).length <= 10 ? dayjs.unix(n2) : dayjs(n2)
  return d2.isValid() ? d2.startOf('day') : dayjs()
}

/**
 * 未分配排期表单：根据计划行与时长得到默认开始 HH:mm
 */
export function getUnassignedDefaultOrPlanStartHm (plan, serviceTimeRaw) {
  const sm = normalizeServiceMinutes(serviceTimeRaw)
  const hasValid = isValidServiceMinutes(sm)
  const nextDate = initialAppointmentDate(plan)
  const fromPlan = planInitialStartHm(plan)
  return fromPlan || getDefaultAppointmentStartHm(nextDate, hasValid ? sm : 60)
}
